export const NOT_AUTHORIZE_LOGIN_PATH = [
  'privacySecurity',
  'accountSettings',
  'personalizedRecommendation'
];
